import React from 'react';
import logo from './../images/cpa-logo.png';
import bpointLogo from './../images/bpoint.png';
import cbaLogo from './../images/cba.jpg';
import Grid from '@mui/material/Grid';
import  Divider  from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

function Logo(props){
    return(
      <img src={props.image} className={props.class} alt={props.alt} />
    );
  }

  export const Header = () => {
    return (
        <div className="Header">
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                sx={{mb:5}}
            >   
                <Grid item xs={12}>
                    <Logo image={logo} class="logo" alt="Cerebral Palsy Alliance Logo"/>
                </Grid>
                
                <Divider sx={{mb:3}}>
                    
                </Divider>
                    
                
            </Grid>
      </div>
    );
}